import React from "react";

export default function Info() {
  return (
    <>
      <div className="p-5">
        <div className="bg-white p-3 rounded-3xl">
          <center>
            <a href="/" className="text-3xl">
              Share<span className="text-primary">Me</span>
            </a>
          </center>
          <br />
          <p>
            Shareme a book sharing platform was initially developed by{" "}
            <b>Team Bodhi Innovators</b> in the{" "}
            <b>Sagarmatha TechFest Hackathon 2023</b> with an idea to let people
            give away their books to those who really need it.
          </p>{" "}
          <br />
          <p>
            Later, <b>ROE Network</b> took this website with a deal to manage
            and serve this website , The website may not give them profit yet
            they are serving our purpose, so we(Team Bodhi Innovators) give a
            huge respect to the new Team.
          </p>
        </div>
        <br />
        <span className="text-2xl">Creators:</span>
        <p>
          {" "}
          This page is to give the team credit to serve this platform with no
          profit .
        </p>
        <div className="text-primary hover:text-black">
          <br />
          <br />
          <div className="p-3 bg-white  rounded-2xl">
            <a href="https://facebook.com/samirkhanalofficial">Samir Khanal</a>
          </div>
          <br />
          <div className="p-3 bg-white  rounded-2xl">
            <a href="https://facebook.com/profile.php?id=100084393906593">
              Srishti Devi Mahatara
            </a>
          </div>
          <br />
          <div className="p-3 bg-white  rounded-2xl">
            <a href="https://facebook.com/kabina.shrestha.9216">
              Kabina Shrestha
            </a>
          </div>
          <br />
          <div className="p-3 bg-white  rounded-2xl">
            <a href="https://facebook.com/imbabitaawasthi">Babita Awasthi</a>
          </div>
        </div>
      </div>
    </>
  );
}
